export class PhoneDto {

  public id!: string;
  public number!: string;
  public prime!: boolean;
  public label: string | undefined;
  public showOnInvoice: boolean | undefined;

  constructor(init?: Partial<PhoneDto> | undefined) {
    Object.assign(this, init);
  }
}
